module.exports = __webpack_public_path__ + "img/4.Μεγανήσι-min.a6cd40e2.jpg";